import { styled } from '@linaria/react';
import { colors, fonts, space } from '../../../theme/tokens';

export const MonthWrapper = styled.div`
  width: 100%;
`;

export const MonthHeader = styled.div`
  text-align: center;
  padding: ${space[2]} 0 ${space[3]};
  font-family: ${fonts.body};
  font-size: 0.9375rem;
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
`;

export const WeekdayRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
  margin-bottom: 4px;
`;

export const WeekdayLabel = styled.span`
  text-align: center;
  font-family: ${fonts.body};
  font-size: 0.6875rem;
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontSecondary};
  text-transform: uppercase;
  padding: 4px 0;
`;

export const DaysGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
`;

export const DayWrapper = styled.div`
  &:hover {
    z-index: 1;
  }
`;
